export default __webpack_public_path__ + "static/media/smarter-exchange.999a629e.svg";